import whatsAppLogo from 'assets/images/backoffice/fresh/whatsapp-logo.png';
import React from 'react';
import './PhaseOut.css';

const WaMe = ({ mobile }) => {
  const wrapper = mobile ? 'wa-me-mobile' : 'wa-wrapper';
  return (
    <div className={wrapper}>
      <p>Masih ada pertanyaan?</p>
      <a target="_blank" href="https://wa.me/6287887423349" className="wa-me">
        <img src={whatsAppLogo} />
        <p>Hubungi via Whatsapp</p>
      </a>
    </div>
  );
};

export default WaMe;
